@if (order?.id || this.serviceId) {
  <form action="your-action" (submit)="onFormSubmit($event)">
    <app-order-bread-crump></app-order-bread-crump>
    <app-order-title [order]="order"></app-order-title>
    <div class="order mt-65">
      <app-order-base-attrs [order]="order"></app-order-base-attrs>
      <div>
        <app-order-status
          [order]="order"
          [externalRate]="this.externalRate"
          [externalNextStatusId]="this.externalNextStatusId"
          class="d-block top-65"></app-order-status>
        <app-order-dynamic-attrs #dynamicAttrs [order]="order" class="d-block"></app-order-dynamic-attrs>
      </div>
    </div>
    <dx-tab-panel
      [dataSource]="pages"
      [selectedIndex]="0"
      [loop]="true"
      [animationEnabled]="true"
      [swipeEnabled]="false"
      [showNavButtons]="false"
      [scrollByContent]="true"
      [scrollingEnabled]="true"
      class="mb-2">
      <div *dxTemplate="let page of 'title'">
        <span>{{ page.caption | translate }}</span>
      </div>
      <div *dxTemplate="let page of 'item'" class="dx-tab-panel-block">
        <dx-scroll-view direction="both" showScrollbar="OnHover" useNative="false" scrollByThumb="true">
          @if (page.id === 1) {
            <div>
              <app-order-tab-basic [order]="order" class="mb-3"></app-order-tab-basic>
            </div>
          }
          @if (page.id === 2) {
            <div>
              <app-order-tab-actions [order]="order" class="d-block"></app-order-tab-actions>
            </div>
          }
          @if (page.id === 3) {
            <div>
              <app-order-tab-files [order]="order" class="d-block mb-3"></app-order-tab-files>
            </div>
          }
        </dx-scroll-view>
      </div>
    </dx-tab-panel>
    <app-order-total [order]="order" [sourceOrder]="sourceOrder"></app-order-total>
  </form>
}

@if (!(order?.id || this.serviceId)) {
  <div class="dx-datagrid-nodata">
    {{ 'ORDER_NOT_FOUND' | translate }}
  </div>
}
